// =============================================
// src/components/Footer.tsx
// =============================================
import React from 'react';
import { Box, Container, Typography, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

const Footer: React.FC = () => {
  return (
    <Box
      sx={{
        bgcolor: '#0a1428',
        color: 'white',
        py: 6,
        mt: 'auto',
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 3,
          }}
        >
          {/* Copyright */}
          <Typography variant="body2" color="rgba(255,255,255,0.7)">
            © {new Date().getFullYear()} Route Royale. All rights reserved.
          </Typography>

          {/* Social Icons */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            <IconButton
              color="inherit"
              aria-label="Facebook"
              sx={{ '&:hover': { color: '#3b82f6' } }}
            >
              <FacebookIcon />
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="Twitter"
              sx={{ '&:hover': { color: '#3b82f6' } }}
            >
              <TwitterIcon />
            </IconButton>
            <IconButton
              color="inherit"
              aria-label="Instagram"
              sx={{ '&:hover': { color: '#3b82f6' } }}
            >
              <InstagramIcon />
            </IconButton>
          </Box>

          {/* Optional extra links (you can remove if you want it even simpler) */}
          <Box sx={{ display: 'flex', gap: 3, fontSize: '0.9rem' }}>
            <Typography variant="body2" color="rgba(255,255,255,0.7)" sx={{ cursor: 'pointer' }}>
              Privacy Policy
            </Typography>
            <Typography variant="body2" color="rgba(255,255,255,0.7)" sx={{ cursor: 'pointer' }}>
              Terms of Service
            </Typography>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;